import { render, staticRenderFns } from "./UnionFieldList.vue?vue&type=template&id=58ffc510&scoped=true&"
import script from "./UnionFieldList.vue?vue&type=script&lang=js&"
export * from "./UnionFieldList.vue?vue&type=script&lang=js&"
import style0 from "./UnionFieldList.vue?vue&type=style&index=0&id=58ffc510&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ffc510",
  null
  
)

export default component.exports